export enum BackgroundImageSize {
	CONTAIN = "contain",
	COVER = "cover",
}
